import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/hooks/useAuth';
import { supabase } from '@/integrations/supabase/client';

export const useUserProfile = () => {
  const { user } = useAuth();

  const { data: profile, isLoading, error } = useQuery({
    queryKey: ['user-profile', user?.id],
    queryFn: async () => {
      if (!user?.id) return null;
      
      // CRITICAL: Support both old and new profile schema
      // Old schema: profiles.id = auth.users.id (auth_user_id is NULL)
      // New schema: profiles.auth_user_id = auth.users.id
      const { data, error } = await supabase
        .from('profiles')
        .select('*')
        .or(`id.eq.${user.id},auth_user_id.eq.${user.id}`)
        .order('created_at', { ascending: true })
        .limit(1)
        .maybeSingle();
      
      if (error) throw error;
      return data;
    },
    enabled: !!user?.id,
  });

  return {
    profile,
    profileId: profile?.id,
    isLoading,
    error,
  };
};